import Footer from "../components/Footer";
import ResponsiveDrawer from "../components/AuthDrawer";
import * as React from "react";


const AuthBase = ({children, label, buttons, filterButtons, filterButtonsMobile}) => {
    return <>
        <ResponsiveDrawer label={label} buttons={buttons} filterButtons={filterButtons} filterButtonsMobile={filterButtonsMobile}>
            <div className="base-container">
                {children}
            </div>
            <Footer/>
        </ResponsiveDrawer>
    </>
}

export default AuthBase